'use client';
import AppImage from '@/components/ui/AppImage';

export default function VideoSection() {
  return (
    <section className="py-32 px-6 bg-background reveal">
      <div className="max-w-7xl mx-auto">
        {/* Product Visual */}
        <div className="relative max-w-3xl mx-auto mb-16">
          <AppImage
            src="https://img.rocket.new/generatedImages/rocket_gen_img_1a22c3d3f-1770758049517.png"
            alt="IGNISS // 001 flame-effect diffuser with visible mist and fire-style lighting"
            className="w-full rounded-[3rem] shadow-2xl"
            width={800}
            height={800} />
          
          <p className="text-center text-muted-foreground mt-6 text-lg">
            No real flame. No heat. Pure atmosphere.
          </p>
        </div>

        {/* Product Story */}
        <div className="max-w-2xl mx-auto text-center space-y-8">
          <p className="text-2xl md:text-3xl font-serif text-foreground leading-relaxed">
            Most rooms are lit. Few are felt.
          </p>

          <p className="text-xl text-muted-foreground leading-relaxed">
            IGNISS // 001 was created to change how a space feels, not how it looks on a shelf.
          </p>

          <p className="text-lg text-muted-foreground leading-relaxed">
            Flame-inspired light. Gentle ultrasonic mist. Silent operation.
          </p>

          <p className="text-xl font-serif text-foreground">
            Designed to slow the room down.
          </p>
        </div>
      </div>
    </section>);

}